import {Component} from "react";
import {connect} from "react-redux";
import {getParam} from "../../../lib/utils";
import * as React from "react";
import http from "../../../lib/http";
import {AgentVerify} from "../../../api/automobileInsurance";
import PageLoading from "../../components/PageLoading";

interface State {
}

interface Props {
	history: any;
}

class Auth extends Component<Props, State> {

	constructor(props) {
		super(props);
		Auth.go2login = Auth.go2login.bind(this);
	}

	componentWillMount() {
		let openId: string = getParam('openId');
		let forward = getParam("forward");
		let orderId = getParam('orderId');
		if (openId && forward) {
			localStorage.setItem("openId", openId);
			localStorage.setItem("forward", forward);
			localStorage.setItem("message-order-id", orderId);
			http['get'](AgentVerify + '?openId=' + openId)
				.then(res => {
					if (res.data.result) {
						let status = res.data.result.status;
						if (status === 0) {
							sessionStorage.setItem("xtoken", res.data.result.data);
							let companyCode = res.data.result.companyCode;
							localStorage.setItem("companyCode",companyCode);
							if(companyCode==="101" || companyCode==="201"){
								//登录态正常
								if (forward === "agent") {
									window.location.replace(process.env.REACT_APP_SALE_INDEX + "?openId=" + openId);
								} else if (forward === "client") {
									localStorage.removeItem("order-currentIndex");
									window.location.replace(process.env.REACT_APP_ORDER_INDEX + "?openId=" + openId);
                                } else if (forward === "message") {
                                    window.location.replace(process.env.REACT_APP_MESSAGE_INDEX + '');
                                } else {
									window.location.replace(process.env.REACT_APP_SALE_INDEX + "?openId=" + openId);
								}
							}else{
								let LOOK_ONLY = process.env.REACT_APP_LOOK_ONLY;
								if (LOOK_ONLY) {
									window.location.replace(LOOK_ONLY);
								}
							}
						} else if (status === -1) {
							//无效代理人
							let auth_invalid = process.env.REACT_APP_AUTH_INVALID;
							if (auth_invalid) {
								window.location.replace(auth_invalid);
							}
						} else {
							//未登录-3,绑定多个代理人-4
							Auth.go2login(openId, forward);
						}
					} else {
						Auth.go2login(openId, forward);
					}
				})
				.catch(ex => {
					Auth.go2login(openId, forward);
				})
		}
	}

	static go2login(openId, forward) {
		window.location.replace(process.env.REACT_APP_LOGIN + "?forward=" + forward + "&openId=" + openId);
	}

	render() {
		return (
			<PageLoading/>
		)
	}
}

const mapStateToProps = (state: any) => ({});

const mapDispatchToProps = (dispatch: any) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(Auth);
